<script lang="ts">
	import { page } from '$app/stores';

	const defaultSeoData = {
		title: 'Herd - Browser Superpowers & MCP Servers for AI Agents',
		description:
			'Automate tasks, extract data, create AI web tools, and manage MCP servers in your browser or across millions of them. Secure, private, and scalable.',
		keywords:
			'browser automation, data extraction, AI web tools, secure browsing, scalable automation, mcp, model context protocol',
		ogType: 'website',
		ogImage: '/social.png',
		canonicalUrl: '',
		noIndex: false
	};
	/**
	 * SEO data passed from the layout data
	 * Will be used to render appropriate meta tags
	 */
	export let data = {};

	$: mergedData = { ...defaultSeoData, ...data };

	// Get current path for canonical URL generation if not provided
	$: path = $page.url.pathname;

	// Generate full URLs
	$: baseUrl = 'https://herd.garden';
	$: canonicalUrl = mergedData.canonicalUrl
		? mergedData.canonicalUrl.startsWith('http')
			? mergedData.canonicalUrl
			: `${baseUrl}${mergedData.canonicalUrl}`
		: `${baseUrl}${path}`;

	// Process OG image to ensure full URL
	$: ogImage = mergedData.ogImage || defaultSeoData.ogImage;
	$: fullOgImage = ogImage?.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`;

	$: ld =
		`<script type="application/ld+json">${JSON.stringify({
			'@context': 'https://schema.org',
			'@type': 'WebSite',
			url: canonicalUrl,
			name: mergedData.title,
			description: mergedData.description,
			image: fullOgImage
		})}</` + 'script>';
</script>

<svelte:head>
	<!-- Basic Meta Tags -->
	<title>{mergedData.title}</title>
	<meta name="description" content={mergedData.description} />
	{#if mergedData.keywords}
		<meta name="keywords" content={mergedData.keywords} />
	{/if}

	<!-- Canonical URL -->
	<link rel="canonical" href={canonicalUrl} />

	<!-- Open Graph Meta Tags -->
	<meta property="og:title" content={mergedData.title} />
	<meta property="og:description" content={mergedData.description} />
	<meta property="og:url" content={canonicalUrl} />
	<meta property="og:type" content={mergedData.ogType || defaultSeoData.ogType} />
	<meta property="og:image" content={fullOgImage} />
	<meta property="og:site_name" content="Herd" />

	<!-- Twitter Card Meta Tags -->
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:title" content={mergedData.title} />
	<meta name="twitter:description" content={mergedData.description} />
	<meta name="twitter:image" content={fullOgImage} />

	<!-- Robots directive -->
	<meta name="robots" content={mergedData.noIndex ? 'noindex, nofollow' : 'index, follow'} />

	<!-- JSON-LD -->

	{@html ld}
</svelte:head>
